export default __webpack_public_path__ + "atomic/_patterns/02-molecules/myseed-certificate/_myseed-certificate.twig";